import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { ApiClient } from './api.client.js';
import { type CreateEmergencyContact, type EmergencyContact, type UpdateEmergencyContact } from '../models/index.js';


export const EmergencyContactsApiKeys = {
  CREATE_EMERGENCY_CONTACT: 'CREATE_EMERGENCY_CONTACT',
  UPDATE_EMERGENCY_CONTACT: 'UPDATE_EMERGENCY_CONTACT',
  DELETE_EMERGENCY_CONTACT: 'DELETE_EMERGENCY_CONTACT',
};

export class EmergencyContactsApi extends ApiClient {
  public static createEmergencyContact(emergencyContact: CreateEmergencyContact): Promise<EmergencyContact> {
    return this.http.post(`/emergency-contacts`, emergencyContact);
  }
  public static updateEmergencyContact(emergencyContact: UpdateEmergencyContact): Promise<EmergencyContact> {
    return this.http.put(`/emergency-contacts/${emergencyContact.id}`, emergencyContact);
  }
  public static deleteEmergencyContact(id: string): Promise<void> {
    return this.http.delete(`/emergency-contacts/${id}`);
  }
}

export function useMutateCreateEmergencyContact(mutationOptions?: UseMutationOptions<EmergencyContact, unknown, CreateEmergencyContact>) {
  return useMutation([EmergencyContactsApiKeys.CREATE_EMERGENCY_CONTACT], (emergencyContact: CreateEmergencyContact) => EmergencyContactsApi.createEmergencyContact(emergencyContact), mutationOptions);
}
export function useMutateUpdateEmergencyContact(mutationOptions?: UseMutationOptions<EmergencyContact, unknown, UpdateEmergencyContact>) {
  return useMutation([EmergencyContactsApiKeys.UPDATE_EMERGENCY_CONTACT], (emergencyContact: UpdateEmergencyContact) => EmergencyContactsApi.updateEmergencyContact(emergencyContact), mutationOptions);
}
export function useMutateDeleteEmergencyContact(mutationOptions?: UseMutationOptions<void, unknown, string>) {
  return useMutation([EmergencyContactsApiKeys.DELETE_EMERGENCY_CONTACT], (id: string) => EmergencyContactsApi.deleteEmergencyContact(id), mutationOptions);
}
